export default __webpack_public_path__ + "static/media/technologyBg1.f234df19.png";